import { createContext, PropsWithChildren, useEffect, useRef, useState } from 'react'

import { Toast, ToastPhase } from '@/components/Toast'

interface ToastContextProps {
  show: (message: string) => void
}

export const ToastContext = createContext<ToastContextProps>({
  show: () => {}
})

const FADE_DURATION_MS = 250
const VISIBLE_DURATION_MS = 4000

export const ToastProvider = ({ children }: PropsWithChildren) => {
  const [message, setMessage] = useState('')
  const [phase, setPhase] = useState<ToastPhase>('hidden')
  const hideTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null)
  const outTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  const clearTimers = () => {
    if (hideTimerRef.current) clearTimeout(hideTimerRef.current)
    if (outTimerRef.current) clearTimeout(outTimerRef.current)
  }

  useEffect(() => () => clearTimers(), [])

  const show = (msg: string) => {
    clearTimers()
    setMessage(msg)
    setPhase('in')
    outTimerRef.current = setTimeout(() => {
      setPhase('out')
      hideTimerRef.current = setTimeout(() => setPhase('hidden'), FADE_DURATION_MS)
    }, VISIBLE_DURATION_MS)
  }

  return (
    <ToastContext.Provider value={{ show }}>
      {children}
      <Toast message={message} phase={phase} />
    </ToastContext.Provider>
  )
}
